export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/daily-cash-summary/:pageId',
        component: () => import('@/views/page/company/core-accounting/summary/DailyCashSummary.vue'),
        name: 'daily-cash-summary',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/cheque-register/:pageId',
        component: () => import('@/views/page/company/core-accounting/cheque-register/List.vue'),
        name: 'cheque-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payment-requisition-summary/:pageId',
        component: () => import('@/views/page/company/core-accounting/cheque-register/PaymentRequestSummary.vue'),
        name: 'payment-requisition-summary',
        meta: {
            requiresAuth: true
        }
    },
]